// Group readable paragraphs independently of the provider's short display lines.
export function transcriptParagraphs(words) {
  const groups=[];
  for(const word of words){
    let group=groups.at(-1),previous=group?.at(-1);
    if(!group || (previous?.speaker && word.speaker && previous.speaker!==word.speaker) ||
      (group.length>=8 && word.start-previous.end>1.5) ||
      (group.length>=40 && /[.!?]["')]*$/.test(previous.text)) || group.length>=75){group=[];groups.push(group);}
    group.push(word);
  }
  return groups;
}
export function wordIdsInRange(container, range) {
  // Limit native browser selection to this transcript, including partially selected words.
  return [...container.querySelectorAll('[data-word-id]')].filter(node=>range.intersectsNode(node)).map(node=>node.dataset.wordId);
}

// Inline words can occupy multiple line boxes. Compare actual fragments rather
// than the bounding rectangle, which includes empty space between wrapped lines.
export function nearestTranscriptWord(elements,x,y) {
  let best=null,distance=Infinity;
  for(const element of elements){
    for(const rect of element.getClientRects()){
      if(!rect.width || !rect.height)continue;
      const dx=Math.max(rect.left-x,0,x-rect.right);
      const dy=Math.max(rect.top-y,0,y-rect.bottom);
      const score=dy*10000+dx;
      if(score<distance){distance=score;best=element;}
    }
  }
  return best;
}

/** Inclusive word range in on-screen order (handles selecting backwards). */
export function wordIdsBetween(elements,startId,endId){
  const ids=elements.map(el=>String(el.dataset.wordId));
  const start=ids.indexOf(String(startId)),end=ids.indexOf(String(endId));
  if(start<0 || end<0)return [];
  return ids.slice(Math.min(start,end),Math.max(start,end)+1);
}
